import { render, staticRenderFns } from "./GrantLogModel.vue?vue&type=template&id=25ba2d31&scoped=true&"
import script from "./GrantLogModel.vue?vue&type=script&lang=js&"
export * from "./GrantLogModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ba2d31",
  null
  
)

export default component.exports